import React from 'react';
import { useHistory } from 'react-router-dom';

import IconBack from './icons/Back.svg';
import { NavButton, Icon, Text } from './ClickableTextButton.styles';

const ClickableTextButton = ({ text, url = '', type, showIcon = false, customIcon, onClick = () => {}, buttonStyle, textStyle }) => {
  const history = useHistory();
  return (
    <NavButton align="middle" onClick={url ? () => history.push(url) : onClick} style={buttonStyle}>
      {showIcon && <Icon src={type === 'back' ? IconBack : customIcon} width="32px" height="32px" alt={text} />}
      <Text style={textStyle}>{text}</Text>
    </NavButton>
  );
};

export default ClickableTextButton;
